import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from '@/store'
import Plugin from '@/common/plugins'
import cookie from '@/common/utils/cookie'
import constant from '@/common/resources/constant'
import { isPrerenderer } from '@/common/utils/common'
import pz from '@/common/utils/pz'
import { redirect } from '@/common/utils/redirect/redirect'

Vue.config.productionTip = false

Plugin.install()

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app')

const toUrl = location.pathname + location.search

if (isPrerenderer()) {
  cookie.setItem(
    'pz',
    JSON.stringify({ isPooqzone: false }),
    false,
    constant.URL_COOKIE_DOMAIN,
    '/',
  )
} else {
  if (!cookie.wasSetWavveOn()) {
    pz.wavveOnCheck(toUrl)
  }
  redirect()
}
